<template>
    <div class="modal fade" id="modal_details_expense" tabindex="-1" data-bs-backdrop='static' aria-hidden="true">

        <div class="modal-dialog modal-xl">
            <div class="modal-content position-relative">
                <loader-gif v-if="isRequestPayment" />
                <div class="modal-header">
                    <h5 class="modal-title" id="varyingModalLabel">
                        {{ i18n.t('layout.sidbar.expenses.details') }}

                    </h5>
                    <button @click="closeModal('modal_details_expense', 'view')" type="button" class="btn-close"
                        aria-label="btn-close"></button>
                </div>
                <div class="modal-body">

                    <div class="row mb-3">
                        <div class="col-md-12">
                            <h4 class="title-h4">
                                {{ i18n.t('views.clients.expense.payment.info') }}
                            </h4>
                        </div>
                    </div>
                    <div class="row mb-5">

                        <div class="col-md-6">
                            <div class="form-group mb-1 mt-1">
                                <b class="d-inline-block w-160"> {{ i18n.t('tables.expense.title') }} </b> : {{
                                    expense?.title ?? '' }}
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group mb-1 mt-1">
                                <b class="d-inline-block w-160"> {{ i18n.t('tables.expense.category_name') }} </b> :
                                <span>{{ expense?.service?.category?.name ?? '' }}</span>

                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group mb-1 mt-1">
                                <b class="d-inline-block w-160"> {{ i18n.t('tables.expense.service_name') }} </b>:
                                <span>{{ expense?.service?.name ?? '' }}</span>

                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group mb-1 mt-1">
                                <b class="d-inline-block w-160"> {{ i18n.t('tables.expense.total_amount') }} </b>:
                                {{ expense?.total_amount ?? 0 }} {{ i18n.t('symbole.currency.mad') }}
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group mb-1 mt-1">
                                <b class="d-inline-block w-160">{{ i18n.t('tables.expense.total_amount_paid') }}
                                </b> :
                                {{ expense?.total_amount_paid ?? 0 }} {{ i18n.t('symbole.currency.mad') }}
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div v-if="expense?.remaining_amount > 0" class="form-group mb-1 mt-1">
                                <b class="d-inline-block w-160"> {{ i18n.t('tables.expense.remaining_amount') }}
                                </b> :
                                {{ expense?.remaining_amount ?? 0 }} {{ i18n.t('symbole.currency.mad') }}
                            </div>
                            <div v-if="expense?.remaining_amount <= 0" class="form-group mb-1 mt-1">
                                <p class="timeline-content">
                                    <b class="d-inline-block w-160"> {{
                                        i18n.t('tables.subscription_member.remaining_amount') }} </b>:
                                    <span class="badges badges-bg badges-actif">{{
                                        i18n.t('tables.subscription_member.paid') }}</span>
                                </p>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group mb-1 mt-1">
                                <b class="d-inline-block w-160">{{ i18n.t('tables.expense.description') }}
                                </b> :
                                {{ expense?.description ?? '' }}
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group mb-1 mt-1">
                                <b class="d-inline-block w-160">{{ i18n.t('tables.expense.date') }}
                                </b> :
                                {{ formatDate(expense?.date) }}
                            </div>
                        </div>

                    </div>
                    <div class="row  mb-3">
                        <div class="col-md-12">
                            <h4 class="title-h4">
                                {{ i18n.t('views.clients.expense.payment.paid') }}
                            </h4>

                        </div>
                    </div>
                    <div v-if="expensesPaymentsList?.length > 0" class="tab-pane fade in active show" id="expenses"
                        style="overflow-x: auto;">
                        <table class="datatables table table-striped table-bordered  ">
                            <thead class="thead-dark">
                                <tr>
                                    <th>
                                        {{ i18n.t('tables.payment.paymentDate') }}
                                    </th>

                                    <th>
                                        {{ i18n.t('tables.payment.paymentMethod') }}
                                    </th>
                                    <th>
                                        {{ i18n.t('tables.payment.chequeName') }}
                                    </th>
                                    <th>
                                        {{ i18n.t('tables.payment.bankName') }}
                                    </th>
                                    <th>
                                        {{ i18n.t('tables.payment.chequeNum') }}
                                    </th>
                                    <th>
                                        {{ i18n.t('tables.payment.dueDate') }}
                                    </th>
                                    <th>
                                        {{ i18n.t('tables.payment.amount_paid') }}
                                    </th>
                                    <th>
                                        {{ i18n.t('tables.action') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(transaction) in expensesPaymentsList" v-bind:key="transaction?.id">
                                    <td>
                                        {{ formatDate(transaction?.paymentDate) }}
                                    </td>
                                    <td>
                                        {{ transaction.paymentMethod }}
                                    </td>
                                    <td>
                                        {{ transaction.chequeName }}
                                    </td>

                                    <td>
                                        {{ transaction?.bankName }}
                                    </td>

                                    <td>
                                        {{ transaction?.chequeNum }}
                                    </td>
                                    <td>
                                        {{ formatDate(transaction?.dueDate) }}
                                    </td>
                                    <td>
                                        {{ transaction?.amount_paid ?? 0.00 }} {{ i18n.t('symbole.currency.mad') }}
                                    </td>
                                    <td>
                                        <btn-delete @delete="Delete(transaction?.id)" />
                                    </td>
                                </tr>

                            </tbody>
                        </table>

                    </div>
                    <div v-else>
                        <not-found :text="i18n.t('message.data_not_found.title')" icon="warning" />
                    </div>

                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import { defineComponent, ref, computed, watch, toRefs } from "vue";
/*Components*/


/*plugins*/
import Swal from "sweetalert2";
import i18n from "@/i18n/index"
//import dayjs from 'dayjs';
/*composables & states */
import { useModal } from '@/composables/modal/useModal';
import { clubUUID, transactions, singleExpense } from "@/shared/state";
import { useGlobal } from "@/composables/global/useGlobal";

import { usePayment } from "@/composables/payment/usePayment";
import { TransactionQueryParams } from "@/interfaces/payment";


export default defineComponent({
    components: {},
    name: "SomeComponent",
    props: {

    },
    emits: ['deletePayment'],
    setup(props, { emit }) {
        const { formatDate } = useGlobal();


        const { closeModal } = useModal();

        const expensesPaymentsList = computed(() => transactions.data);
        const expense = computed(() => singleExpense.data);

        const searchBy = ref<TransactionQueryParams>({
            id: null,
            pack_id: null,
            subscription_id: null,
            is_renewal: null,
            clubUUID: clubUUID.value,
            memberUUID: null,
            memberName: "",
            memberCIN: "",
            memberTele: "",
            memberContract: "",
            paymentMethod: "",
            bankName: null,
            chequeName: null,
            chequeNum: null,
            dueDate: [],
            paymentDate: null,
            status: "paid",
            type: "all",
            page: null,
            limit: null,
            with_member: "false",
            summary: "true",
            reference_id: expense?.value?.id ?? null,
            reference_type: "expenses"
        });
        const fetchTransactionsData = () => {
            searchBy.value.page = 1
            fetchTransactions(searchBy.value);
        };
        const { fetchTransactions, deletePayment, isRequestPayment } = usePayment();


      
        /**
     * Delete Expense by ID
     */
        const Delete = (paymentID: number) => {
            if (expense?.value) {
                Swal.fire({
                    title: i18n.t("message.confirmation.payment.delete.title"),
                    text: i18n.t("message.confirmation.payment.delete.text"),
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: i18n.t("button.delete"),
                    cancelButtonText: i18n.t("button.cancel"),
                    allowOutsideClick: false, // ✅ disable closing by clicking outside
                    allowEscapeKey: false, // (optional) disable closing with ESC
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        deletePayment(paymentID).then((res) => {
                           fetchTransactionsData()
                            emit('deletePayment')
                        })
                    }
                });
            }
        };


        watch(
            () => expense.value,
            (newValue) => {
                if (expense?.value) {
                    transactions.data = []
                    searchBy.value.reference_id = expense?.value?.id ?? null
                    fetchTransactionsData()
                }
            });




        return {
            expense,
            expensesPaymentsList,
            formatDate,
            i18n,
            closeModal,
            Delete,
            isRequestPayment
        };
    },
});
</script>
